import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_PROVISIONING_SUPABASE_URL;
const anonKey = import.meta.env.VITE_PROVISIONING_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    "VITE_PROVISIONING_SUPABASE_URL and VITE_PROVISIONING_SUPABASE_ANON_KEY must be set"
  );
}

export const supabase = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
  },
});
